import { SyncFrequencyOption } from '../../../shared/interfaces/integration';

export const getPredefinedSyncFrequencyOptionFromMillis = (
  featureOptions: SyncFrequencyOption[],
  valueInMillis: number
) => {
  return featureOptions.find(option => option.value === valueInMillis);
};
